'use client';

import { useId, useState } from 'react';
import { useRouter } from 'next/navigation';
import { ArrowUpRight } from 'lucide-react';

export function ChartPrompt({ id }: { id?: string }) {
  const [prompt, setPrompt] = useState('');
  const [error, setError] = useState('');
  const generatedId = useId();
  const inputId = id || generatedId;
  const router = useRouter();
  return (
    <form
      className="marketing-prompt"
      onSubmit={event => {
        event.preventDefault();
        if (!prompt.trim()) return;
        const encoded = encodeURIComponent(prompt.trim());
        // Leave room for the cookie name and attributes within browser limits.
        if (encoded.length > 3500) {
          setError('Start with a shorter question. You can add your data in the workspace.');
          return;
        }
        document.cookie = `pending_prompt=${encoded}; path=/; max-age=3600; SameSite=Lax`;
        router.push('/chat');
      }}>
      <label htmlFor={inputId}>What would you like to visualize?</label>
      <div>
        <input
          id={inputId}
          type="text"
          value={prompt}
          maxLength={2000}
          required
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${inputId}-error` : undefined}
          placeholder="Compare monthly sales as a bar chart..."
          onChange={event => {
            setPrompt(event.target.value);
            setError('');
          }}
        />
        <button type="submit" className="marketing-button" disabled={!prompt.trim()}>
          Create a chart <ArrowUpRight size={17} aria-hidden="true" />
        </button>
      </div>
      {error && (
        <p id={`${inputId}-error`} role="alert">
          {error}
        </p>
      )}
    </form>
  );
}
